export const env: any = {
    dev: {
        api: 'https://rd.aurastone.tech',
    },
    test: {
        api: 'https://rd.aurastone.tech',
    },
    prod: {
        api: 'https://lam.vaygopro.com',
    }
}

export const env_api = function (ENV: any) {
    if(ENV === 'dev') {
        return env.dev.api
    }else if (ENV === 'test') {
        return env.test.api
    }else {
        return env.prod.api
    }
}